import Reveal from '../components/Reveal';

const prizes = [
  { img: '/assets/spin/icon-coin.svg',    label: 'Coins' },
  { img: '/assets/spin/icon-hint.svg',    label: 'Hints' },
  { img: '/assets/spin/mascot-celebrate.svg', label: 'Boosters' },
];

export default function SpinWheel() {
  return (
    <div className="spin-bg" id="spin">
      <div className="spin-inner">
        <Reveal>
          <div style={{ position: 'relative' }}>
            <div className="spin-wheel-wrap">
              <div
                className="spin-glow"
                aria-hidden="true"
                style={{
                  backgroundImage: `url(${process.env.PUBLIC_URL}/assets/spin/glow-burst.svg)`,
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                }}
              />
              <img src="/assets/spin/wheel.svg" alt="Reward wheel" className="wheel-img" />
            </div>
            <img
              src="/assets/spin/confetti.svg"
              alt=""
              aria-hidden="true"
              className="spin-confetti"
            />
          </div>
        </Reveal>
        <Reveal delay={120}>
          <div>
            <p className="section-label">Free Rewards</p>
            <h2 className="section-title">Spin the Wheel</h2>
            <p className="section-sub">
              Earn free-spin tickets by playing levels and completing daily challenges.
              Spin the glowing reward wheel for coins, hints, and rare coin boosters.
              Every spin is a win.
            </p>
            <div className="spin-icons">
              {prizes.map((p) => (
                <div key={p.label} className="spin-icon-item">
                  <img src={p.img} alt={p.label} style={{ width: 48, height: 48 }} />
                  <span className="spin-icon-label">{p.label}</span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
